import React, { useCallback, useState } from 'react';

import api from '../api';
import { Provider as name } from '../config';
import { useGet, useGetById, usePost, usePut, useRemove, useSoftDelete } from '../../apiHooks';

import { TravelFileNotesContext } from './context';

interface Props {
    children: React.ReactNode;
}

export const TravelFileNotesProvider: React.FC<Props> = ({ children }: Props) => {
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [error, setError] = useState<any>({});

    const getById = useGetById(api, selected, setSelected, setError);

    const handleGetData = useCallback((res) => {
        setData(res);
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);

    const handleSetData = useCallback((item, newData) => {
        setData(newData);
    }, []);
    const post = usePost(api, data, handleSetData, setError);

    const put = usePut(api, data, handleSetData, setError);

    const handleDeleteCallback = useCallback((id, newData) => {
        setData(newData);
        setSelected({});
        return id;
    }, []);
    const remove = useRemove(api, data, handleDeleteCallback, setError);

    const softDelete = useSoftDelete(api, data, handleDeleteCallback, setError);

    const addNoteToTravelFile = useCallback(async (body) => {
        try {
            return await api.addNoteToTravelFile(body);
        } catch (err) {
            setError(err);
            throw err;
        }
    }, []);

    const editNoteInTravelFile = useCallback(async (body) => {
        try {
            return await api.editNoteInTravelFile(body);
        } catch (err) {
            setError(err);
            throw err;
        }
    }, []);
    const deleteNoteFromTravelFile = useCallback(async (body) => {
        try {
            return await api.deleteNoteFromTravelFile(body);
        } catch (err) {
            setError(err);
            throw err;
        }
    }, []);

    return (
        <TravelFileNotesContext.Provider
            value={{
                name,
                get,
                getById,
                post,
                put,
                data,
                setData,
                selected,
                setSelected,
                remove,
                error,
                softDelete,
                addNoteToTravelFile,
                editNoteInTravelFile,
                deleteNoteFromTravelFile
            }}
        >
            {children}
        </TravelFileNotesContext.Provider>
    );
};

export default TravelFileNotesProvider;
